import { Box, styled } from '@mui/material';

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  marginBottom: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  [theme.breakpoints.down(1200)]: {
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',
    gap: '24px',
  },
}));
